import React, { useEffect } from 'react';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box'

import * as HomeFragment from './HomeFragmentComponent';
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';
import {Loading} from '../custom/LoadingComponent'

function Home(props) {

    useEffect(() => {
        props.loadComponentData();
    }, []);

    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
            
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
    
                <HomeFragment.HomePrivate 
                    clients={props.clients}
                    worksites={props.worksites}
                />
    
            </Box>
            </Container>
        );
    }

}

export default Home;